export default __webpack_public_path__ + "static/media/logo_nbea.90b49106.png";